import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["formatSelect", "meetingUrlContainer", "mapContainer"];

  connect() {
    this.toggleVisibility();
  }

  toggleVisibility() {
    const value = this.formatSelectTarget.value.toLowerCase();

    if (value === "online") {
      this.meetingUrlContainerTarget.classList.remove("hidden");
      if (this.hasMapContainerTarget) {
        this.mapContainerTarget.classList.add("hidden");
      }
    } else {
      this.meetingUrlContainerTarget.classList.add("hidden");
      if (this.hasMapContainerTarget) {
        this.mapContainerTarget.classList.remove("hidden");
        setTimeout(() => {
          const mapPicker =
            this.mapContainerTarget.querySelector(
              '[data-controller="map-picker"]',
            ) || this.mapContainerTarget;
          mapPicker.dispatchEvent(new CustomEvent("map:resize"));
        }, 100);
      }
    }
  }
}
